export default __webpack_public_path__ + "static/media/080_finish_bad.vp9.6161de54.webm";